import { enableProdMode, LOCALE_ID } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { loadTranslations } from '@angular/localize';
import { registerLocaleData } from '@angular/common';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { I18nService } from './app/i18n.service';
import { LanguageLocaleData, LanguageTranslationMap } from './locale-registry';

if (environment.production) {
  enableProdMode();
}

function setBaseHrefForLocale(locale: string | null) {
  const base = document.querySelector('base');
  base.setAttribute('href', !locale || (locale === 'en') ? '/' : `/${locale}/`);
}

async function bootstrap() {
  const svc = new I18nService();
  let lang = svc.current();

  try {
    setBaseHrefForLocale(lang);
    registerLocaleData(LanguageLocaleData[lang], lang);
    loadTranslations(LanguageTranslationMap[lang]);
    await platformBrowserDynamic([{ provide: LOCALE_ID, useValue: lang }]).bootstrapModule(AppModule);
    Object.keys(LanguageTranslationMap).forEach((locale) => delete LanguageTranslationMap[locale]);
    Object.keys(LanguageLocaleData).forEach((locale) => delete LanguageLocaleData[locale]);
  } catch (err) {
    console.error('i18n bootstrap failed; falling back to en', err);
    try {
      loadTranslations(LanguageTranslationMap['en']);
      await platformBrowserDynamic([{ provide: LOCALE_ID, useValue: 'en' }]).bootstrapModule(AppModule);
      Object.keys(LanguageTranslationMap).forEach((locale) => delete LanguageTranslationMap[locale]);
    } catch (e) {
      console.error('fallback bootstrap failed', e);
    }
  }
}

bootstrap();
